export type GetAuthTokens = () => {
  accessToken: string | null;
  refreshToken: string | null;
};

export type SetAuthTokens = (tokens: {
  accessToken: string;
  refreshToken: string;
}) => void;

export type RemoveAuthTokens = () => void;

const getUserAuthTokenKey = () => 'user:accessToken';
const getUserRefreshTokenKey = () => 'user:refreshToken';

export const getUserAuthTokens = () => ({
  accessToken: localStorage.getItem(getUserAuthTokenKey()),
  refreshToken: localStorage.getItem(getUserRefreshTokenKey()),
});

export const setUserAuthTokens = (tokens: {
  accessToken: string;
  refreshToken: string;
}) => {
  localStorage.setItem(getUserAuthTokenKey(), tokens.accessToken);
  localStorage.setItem(getUserRefreshTokenKey(), tokens.refreshToken);
};

export const removeUserAuthTokens = () => {
  localStorage.removeItem(getUserAuthTokenKey());
  localStorage.removeItem(getUserRefreshTokenKey());
};

export const getCustomerAuthTokenKey = (businessId: string) =>
  `customer:accessToken:${businessId}`;

export const getCustomerRefreshTokenKey = (businessId: string) =>
  `customer:refreshToken:${businessId}`;

export const getCustomerAuthTokens = (businessId: string) => ({
  accessToken: localStorage.getItem(getCustomerAuthTokenKey(businessId)),
  refreshToken: localStorage.getItem(getCustomerRefreshTokenKey(businessId)),
});

export const setCustomerAuthTokens = (
  businessId: string,
  tokens: {
    accessToken: string;
    refreshToken: string;
  }
) => {
  localStorage.setItem(getCustomerAuthTokenKey(businessId), tokens.accessToken);
  localStorage.setItem(
    getCustomerRefreshTokenKey(businessId),
    tokens.refreshToken
  );
};

export const removeCustomerAuthTokens = (businessId: string) => {
  localStorage.removeItem(getCustomerAuthTokenKey(businessId));
  localStorage.removeItem(getCustomerRefreshTokenKey(businessId));
};
